/**
 * Copyright 2015, Yahoo! Inc.
 * Copyrights licensed under the New BSD License. See the accompanying LICENSE file for terms.
 */

// 'use strict';

/*
 * Google MapImage Service
 * @class GoogleMapService
 */

Object.defineProperty(exports, '__esModule', {
    value: true,
});

const _createClass = (function() {
    function defineProperties(target, props) {
        for (let i = 0; i < props.length; i++) {
            const descriptor = props[i];
            descriptor.enumerable = descriptor.enumerable || false;
            descriptor.configurable = true;
            if ('value' in descriptor) descriptor.writable = true;
            Object.defineProperty(target, descriptor.key, descriptor);
        }
    }
    return function(Constructor, protoProps, staticProps) {
        if (protoProps) defineProperties(Constructor.prototype, protoProps);
        if (staticProps) defineProperties(Constructor, staticProps);
        return Constructor;
    };
})();

const _config = require('../../config/config.json');

const _url = require('url');

const _url2 = _interopRequireDefault(_url);

function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : { default: obj };
}

function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError('Cannot call a class as a function');
    }
}

const _ = {
    // Collection
    pick: require('lodash/pickBy'),
    identity: require('lodash/identity'),
};

const GoogleMapService = (function() {
    function GoogleMapService() {
        _classCallCheck(this, GoogleMapService);
    }

    _createClass(GoogleMapService, [
        {
            key: 'getMap',

            /**
         * Get the map location details for the address provided in the params
         *
         * @param {Object} params
         * @returns {{mapId: (*|string|string|string|string), data: {locationLink: *, locationText: string}}}
         */
            value: function getMap(params) {
                let location = void 0;
                let url = void 0;

                if (isFinite(params.longitude) && isFinite(params.latitude)) {
                    location = [params.latitude, params.longitude].join(',');
                } else {
                    location = [params.line1, params.line2, params.line3].join(',');
                }

                url = _url2.default.format({
                    protocol: _config.google.protocol,
                    hostname: _config.google.host,
                    pathname: _config.google.path,
                    query: _.pick(
                        {
                            center: location,
                            size: [params.width, params.height].join('x'),
                            mapType: _config.google.mapType,
                            markers: [
                                _config.google.markerColor,
                                _config.google.markerLabel,
                                location,
                            ].join('|'),
                            zoom: params.zoom,
                            key: params.providerKey,
                        },
                        _.identity,
                    ),
                });

                return {
                    mapId: params.mapId,
                    data: {
                        locationLink: url,
                        locationText: location,
                    },
                };
            },
        },
        {
            key: 'name',
            get: function get() {
                return _config.google.name;
            },
        },
    ]);

    return GoogleMapService;
})();

exports.default = GoogleMapService;



// WEBPACK FOOTER //
// ./src/containers/PrivateArea/Meeting/components/react-cartographer/lib/lib/googleMap.js